import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('MenuMobileAccordionContainer')(({ styles }) => css({ ...styles }));

const commonItemStyles = {
  display: 'flex',
  width: '100%',
  alignItems: 'center',
};

themeStyles.addBaseStyles('NavLink')(({ styles, paddingY, isExternal, theme }) =>
  css({
    ...commonItemStyles,
    fontFamily: 'default',
    fontSize: '14px',
    lineHeight: '18px',
    letterSpacing: '0.5',
    color: 'black',
    textDecoration: 'none',
    '& span': {
      ...styles({ isExternal, theme }).linkStyle,
      '&:hover, &:focus': {
        borderBottom: '1px solid',
        borderBottomColor: styles({
          isExternal,
          theme,
        }).showTitleContentBorderBottomLevel2
          ? 'primary'
          : 'transparent',
      },
    },
    py: paddingY,
    ...styles({ isExternal, theme }),
  }),
);
themeStyles.addBaseStyles('TitleH6')(({ styles, theme }) =>
  css({
    ...commonItemStyles,
    ...styles({ theme }),
  }),
);
themeStyles.addBaseStyles('TitleH7')(({ styles, isActive, theme }) =>
  css({
    ...commonItemStyles,
    ...styles({ isActive, theme }),
  }),
);
themeStyles.addBaseStyles('TitleH8')(({ styles, theme }) =>
  css({
    color: '#4a4a4a',
    ...commonItemStyles,
    ...styles({ theme }),
  }),
);

themeStyles.addBaseStyles('ItemIcon')(({ filter }) =>
  css({
    marginRight: 'xs',
    maxHeight: '20px',
    maxWidth: '20px',
    objectFit: 'contain',
    display: 'inline-block',
    filter,
  }),
);

themeStyles.addBaseStyles('ItemImage')(
  css({
    maxHeight: '18px',
    maxWidth: '48px',
    objectFit: 'contain',
    objectPosition: 'left center',
    marginRight: 'm',
  }),
);

themeStyles.addBaseStyles('ExternalIcon')(
  css({
    marginLeft: 'xs',
    height: '12px!important',
    width: '12px!important',
  }),
);

themeStyles.addBaseStyles('AccordionItem')(({ styles, isLastItem, hasDealerItem }) =>
  css({
    display: 'block',
    width: '100%',
    ...styles,
    borderBottomColor: isLastItem || hasDealerItem ? styles.lastItemBottomBorderColor : styles.borderBottomColor,
  }),
);

themeStyles.addBaseStyles('AccordionItemTitle')(({ theme, styles, isActive }) =>
  css({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    zIndex: 'accordionItemTitle',
    justifyContent: 'space-between',
    ...styles({ theme, isActive }),
    ...theme?.focused?.button(theme),
  }),
);

themeStyles.addBaseStyles('AccordionItemContentContainer')(({ showChildren, styles, theme }) =>
  css({
    overflow: 'hidden',
    height: 'auto',
    maxHeight: showChildren ? 'auto' : 0,
    transition: 'max-height 0.3s ease',
    position: 'relative',
    visibility: showChildren ? 'visible' : 'hidden',
    ...styles({ theme, showChildren }),
  }),
);

themeStyles.addBaseStyles('AccordionItemContainer')(({ theme }) =>
  css({
    '&:focus-visible': {
      outline: `solid 8px ${theme.colors.aodaFocused}`,
      outlineOffset: '-8px',
    },
  }),
);

themeStyles.addBaseStyles('DealerName')(({ linkColor }) =>
  css({
    color: linkColor,
    letterSpacing: '0.5px',
    textDecoration: 'underline',
  }),
);

themeStyles.addBaseStyles('FindDealerLink')(({ linkColor }) =>
  css({
    color: linkColor,
    letterSpacing: '0.5px',
  }),
);

themeStyles.addBaseStyles('NavItem')(({ linkColor }) =>
  css({
    color: linkColor,
    letterSpacing: '0.5px',
    lineHeight: '26px',
  }),
);
export default themeStyles;
